import React from 'react';
//import { useLocation } from "react-router-dom";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import SplashScreen from './component/SplashScreen/SplashScreen';
import SignIn from './component/SignIn/SignIn';
import ForgotPswd from './component/ForgotPswd/ForgotPswd';
import Otp from './component/Otp/Otp';
import ChangePswd from './component/ChangePswd/ChangePswd';
import CardVIew from './component/CardVIew/CardVIew';
import Users from './component/Users/Users';
import UserDetails from './component/UserDetails/UserDetails';
import ListView from './component/ListView/ListView';
import ListViewInfo from './component/ListViewInfo/ListViewInfo';
import Dashboard from './component/Dashboard/Dashboard';
import CalendarPage from './component/CalendarPage/CalendarPage';
import UserControl from './component/UserControl/UserControl';
import EmployeeDatabase from './component/EmployeeDatabase/EmployeeDatabase';
import UpdateEmployee from './component/UpdateEmployee/UpdateEmployee';
import SiteDatabase from './component/SiteDatabase/SiteDatabase';
import SiteDetails from './component/SiteDetails/SiteDetails';
import AddSite from './component/AddSite/AddSite';
import AgencyDatabase from './component/AgencyDatabase/AgencyDatabase';
import AgencyDetails from './component/AgencyDetails/AgencyDetails';
import AddAgency from './component/AddAgency/AddAgency';
import PerformancePage from './component/PerformancePage/PerformancePage';
import IndividualPerformance from './component/PerformancePage/IndividualPerformance';
import SettingsPage from './component/SettingsPage/SettingsPage';
import SettingPswd from './component/SettingPswd/SettingPswd';
import SettingReport from './component/SettingReport/SettingReport';
import GalleryMedia from './component/ListViewInfo/GalleryMedia';
import GalleryDoc from './component/ListViewInfo/GalleryDoc';
import Quotation from './component/Quotation/Quotation';
import { AuthProvider, useAuth } from './AuthContext';

//import { AnimatePresence } from "framer-motion";
//import TestPopupForm from './component/Test_PopupForm/Test_PopupForm';

function App() {
  function ProtectedRoute({ element }) {
    const { user } = useAuth();
  
    if (user && element.type === SignIn) {
      return <Navigate to="/Dashboard" />;
    }
  
    return user ? element : <Navigate to="/SignIn" />;
  }
return (
  <div>
    <Router>
      <AuthProvider>
      <Routes>
      <Route path='/' element={<ProtectedRoute element={<SignIn />} />} />
        <Route path='/SplashScreen' element={<ProtectedRoute element={<SplashScreen />}/>} />
        <Route path='/SignIn' element={<ProtectedRoute element={<SignIn />}/>}/>
        <Route path='/ForgotPswd' element={<ProtectedRoute element={<ForgotPswd />} />} />
        <Route path='/Otp' element={<ProtectedRoute element={<Otp />} />} />
        <Route path='/ChangePswd' element={<ProtectedRoute element={<ChangePswd />} />} />
        <Route path='/CardVIew' element={<ProtectedRoute element={<CardVIew />} />} />
        <Route path='/Users' element={<ProtectedRoute element={<Users />} />} />
        <Route path='/UserDetails' element={<ProtectedRoute element={<UserDetails />} />} />
        <Route path='/ListView' element={<ProtectedRoute element={<ListView />} />} />
        <Route path='/ListViewInfo' element={<ProtectedRoute element={<ListViewInfo />} />} />
        <Route path='/Dashboard' element={<ProtectedRoute element={<Dashboard />} />} />
        <Route path='/CalendarPage' element={<ProtectedRoute element={<CalendarPage />} />} />
        <Route path='/UserControl' element={<ProtectedRoute element={<UserControl />} />} />
        <Route path='/EmployeeDatabase' element={<ProtectedRoute element={<EmployeeDatabase />} />} />
        <Route path='/UpdateEmployee' element={<ProtectedRoute element={<UpdateEmployee />} />} />
        <Route path='/SiteDatabase' element={<ProtectedRoute element={<SiteDatabase />} />} />
        <Route path='/SiteDetails' element={<ProtectedRoute element={<SiteDetails />} />} />
        <Route path='/AddSite' element={<ProtectedRoute element={<AddSite />} />} />
        <Route path='/AgencyDatabase' element={<ProtectedRoute element={<AgencyDatabase />} />} />
        <Route path='/AgencyDetails' element={<ProtectedRoute element={<AgencyDetails />} />} />
        <Route path='/AddAgency' element={<ProtectedRoute element={<AddAgency />} />} />
        <Route path='/PerformancePage' element={<ProtectedRoute element={<PerformancePage />} />} />
        <Route path='/IndividualPerformance' element={<ProtectedRoute element={<IndividualPerformance />} />} />
        <Route path='/SettingsPage' element={<ProtectedRoute element={<SettingsPage />} />} />
        <Route path='/SettingPswd' element={<ProtectedRoute element={<SettingPswd />} />} />
        <Route path='/SettingReport' element={<ProtectedRoute element={<SettingReport />} />} />
        <Route path='/GalleryMedia' element={<ProtectedRoute element={<GalleryMedia />} />} />
        <Route path='/GalleryDoc' element={<ProtectedRoute element={<GalleryDoc />} />} />
        <Route path='/Quotation' element={<ProtectedRoute element={<Quotation />} />} />
          
      </Routes>
      </AuthProvider>
    </Router>
  </div>
  );
}

export default App;